import * as S from "../styles";

/* eslint-disable @typescript-eslint/no-unused-vars */
import { Dialog, DialogActions, DialogContent, DialogTitle, Grid } from "@mui/material";
import { useEffect, useState } from "react";

import AutoCompleteMult from "../../../../components/hookForms/autoCompleteMult";
import { Button } from "@mui/material";
import CheckBox from "../../../../components/hookForms/checkbox";
import CloseIcon from "@mui/icons-material/Close";
import DatePickerMui from "../../../../components/hookForms/datePicker";
import IGenericResult from "../../../../interfaces/IGenericResult";
import IconButton from "@mui/material/IconButton";
import { format } from "date-fns";
import messages from "../../../../utils/messages";
import serviceCliente from "../../../../services/serviceCliente";
import serviceRelatorio from "../../../../services/serviceRelatorio";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import { yupResolver } from "@hookform/resolvers/yup";

export interface IDialogProps {
    open: boolean;
    onClose?: any;
}

export default function FaturasCliente({ open, onClose }: IDialogProps) {
    const [clienteDataOptions, setClienteDataOptions] = useState<IGenericResult[]>([]);
    const [disabled, setDisabled] = useState(false);

    const history = useHistory();

    const {
        control,
        handleSubmit,
        reset,
        formState: { errors },
    } = useForm({
        defaultValues: {
            dataInicio: "",
            dataFim: "",
            idsClientes: "",
        },
    });

    useEffect(() => {
        setClienteData();
    }, []);

    const setClienteData = async () => {
        serviceCliente
            .getClientes()
            .then((result) => {
                setClienteDataOptions(result?.data);
            })
            .catch(() => {
                setClienteDataOptions([]);
            });
    };

    const onSubmit = (values: any) => {
        setDisabled(true);

        let dataInicio = new Date(values.dataInicio);
        let dataFim = new Date(values.dataFim);

        const newValues = {
            ...values,
            relatorioTipoID: 11,
            idsClientes: values.idsClientes ? values.idsClientes.join(", ") : "",
            dataInicio: values?.dataInicio ? format(values?.dataInicio, "yyyy-MM-dd") : "",
            dataFim: values?.dataFim ? format(values?.dataFim, "yyyy-MM-dd") : "",
        };

        delete newValues.redirecionar;

        serviceRelatorio
            .getRelatorioFaturasCliente(newValues)
            .then((result) => {
                if (result) {
                    onClose();
                    toast.success(messages.reportSucess);
                }
            })
            .catch(() => {
                toast.error(messages.reportError);
            })
            .finally(() => {
                setDisabled(false);
                if (values.redirecionar) {
                    history.push("/relatorios/listagemrelatorios");
                }
            });
    };

    return (
        <div>
            <Dialog
                maxWidth="md"
                fullWidth
                onClose={(_, reason) => {
                    if (reason !== "backdropClick") {
                        onClose();
                    }
                }}
                open={open}
            >
                <DialogTitle>
                    <S.Title>Gerar relatório: Faturas de clientes</S.Title>
                    <IconButton
                        aria-label="close"
                        onClick={() => {
                            reset();
                            onClose();
                        }}
                        sx={{
                            position: "absolute",
                            right: 8,
                            top: 8,
                            // color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <DialogContent dividers>
                        <Grid item xs={12}>
                            {disabled && (
                                <S.Loader>
                                    <img alt="Loading" src="/Loading.gif" width="40px" height="40px" />
                                </S.Loader>
                            )}
                        </Grid>

                        <S.Subtitles>Período de publicação</S.Subtitles>
                        <Grid container spacing={3}>
                            <Grid item xs={12} md={6}>
                                <DatePickerMui
                                    name="dataInicio"
                                    label="Início"
                                    control={control}
                                    error={errors}
                                    format="dd/MM/yyyy"
                                    view={["day", "month", "year"]}
                                    noDateForward
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <DatePickerMui
                                    name="dataFim"
                                    label="Fim"
                                    control={control}
                                    error={errors}
                                    format="dd/MM/yyyy"
                                    view={["day", "month", "year"]}
                                    noDateForward
                                />
                            </Grid>
                        </Grid>
                        <Grid container>
                            <Grid item xs={12} md={12}>
                                <AutoCompleteMult
                                    name="idsClientes"
                                    label="Clientes"
                                    control={control}
                                    error={errors}
                                    options={clienteDataOptions}
                                    concatWithID={true}
                                    disabled={clienteDataOptions.length <= 0}
                                />
                            </Grid>
                        </Grid>

                        <S.Spacing />

                        <Grid item xs={12} md={6}>
                            <CheckBox
                                name="redirecionar"
                                label="Redirecionar para a tela de relatório"
                                control={control}
                                error={errors}
                            />
                        </Grid>
                    </DialogContent>
                    <DialogActions style={{ display: "flex", justifyContent: "center", margin: "24px" }}>
                        <Button
                            style={{ width: "159px", height: "44px" }}
                            onClick={() => {
                                reset();
                                onClose();
                            }}
                            color="warning"
                            variant="contained"
                        >
                            Cancelar
                        </Button>
                        <Button
                            disabled={disabled}
                            style={{ width: "159px", height: "44px" }}
                            onClick={() => {}}
                            type="submit"
                            variant="contained"
                        >
                            Gerar
                        </Button>
                    </DialogActions>
                </form>
            </Dialog>
        </div>
    );
}
